import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeGetNamesForHandles } from 'reduxes/slices/contacts/selectors'
import { getTypingHandlesForTopic } from 'reduxes/slices/participants/selectors'

import { css } from 'design'
import { Box, Stack } from 'primitives/containers'
import { cn } from 'util/cn'

import { clearAllTypingIndicators } from '../../reduxes/slices/actives/actions'
import { getCurrentTeammateHandle } from '../../reduxes/slices/current/selectors'
import { setComponentValid } from '../../reduxes/slices/invalid/actions'

export const TypingIndicators = () => {
  const currentTeammateHandle = useSelector(getCurrentTeammateHandle)
  const typingHandles = useSelector(getTypingHandlesForTopic) as string[]
  const getNamesForHandles = useMemo(makeGetNamesForHandles, [])
  const names = useSelector((state) =>
    // eslint-disable-next-line
    // @ts-ignore
    getNamesForHandles(state, typingHandles || []),
  )
  // eslint-disable-next-line
  // @ts-ignore
  const isInvalid = useSelector((state) => state.invalid.typing_indicators)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isInvalid) {
      dispatch(clearAllTypingIndicators())
      dispatch(setComponentValid('typing_indicators'))
    }
  }, [dispatch, isInvalid])

  const handlesText = useMemo(() => {
    if (!names) {
      return null
    }

    const contactNames = []
    for (const [key, value] of Object.entries(names)) {
      if (key !== currentTeammateHandle) {
        contactNames.push(value)
      }
    }

    if (contactNames.length === 0) {
      return null
    }

    if (contactNames.length > 3) {
      return 'Several people are typing...'
    }

    if (contactNames.length === 1) {
      return `${contactNames[0]} is typing...`
    }

    return `${contactNames.join(', ')} are typing...`
  }, [names, currentTeammateHandle])

  if (!currentTeammateHandle || !typingHandles || !handlesText) {
    return null
  }

  return (
    <Stack
      as="li"
      gap="4"
      direction="row"
      className={cn('timeline__typing-indicator', typingIndicatorStyles())}
    >
      <Box
        className="timeline__status__line timeline__typing-indicator__typing-block"
        css={{
          alignSelf: 'flex-start',
          marginTop: 6,
        }}
      />
      <Box
        as="span"
        css={{
          color: '$grey700',
          fontSize: '$0',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}
      >
        {handlesText}
      </Box>
    </Stack>
  )
}

const typingIndicatorStyles = css({
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  padding: '$1 $4',
  color: '$grey900',
  maxWidth: '100%',
  position: 'absolute',
  bottom: 6,
})
